import { Stack } from '@locus-taxy/encore-mui';
import { TeamChip } from '@locus-taxy/encore-mui';
import type { Team } from '../../types/team';

interface EntityTeamChipsProps {
  teamIds?: string[];
  teams?: Team[];
}

export default function EntityTeamChips({
  teamIds,
  teams = [],
}: EntityTeamChipsProps) {
  // If no teamIds exist, return null
  if (!teamIds || teamIds.length === 0) {
    return null;
  }

  // Create a map for quick team lookup
  const teamMap = new Map(teams.map(team => [team.id, team]));

  // Display chips for each team with their respective colors
  return (
    <Stack direction="row" gap={0.5} alignItems="center" flexWrap="wrap">
      {teamIds.map(teamId => {
        const team = teamMap.get(teamId);
        return (
          <TeamChip
            key={teamId}
            label={team?.name ?? teamId}
            color={team?.color ?? ''}
          />
        );
      })}
    </Stack>
  );
}
